import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDsLanhDaoPhongTheoIdDonVi } from '../../services/nhanvien';

const LanhDaoPhongBanSelectBox = ({ value, optionAll, disabled, idDonVi, multiple, allowClear, onChange }: { value?: number, optionAll?: boolean, disabled?: boolean, idDonVi?: number, multiple?: boolean, allowClear?: boolean, onChange?: (e: any) => void }) => {
    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDsLanhDaoPhongTheoIdDonVi(idDonVi ?? 0);
            if (optionAll && rs.length > 1) {
                rs = [{ value: 0, label: "--Tất cả--" }, ...rs];
            }
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, [idDonVi]);
    return (
        multiple ? 
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn đại diện phòng--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            disabled={disabled}
            value={value}
            mode= 'multiple'
            onChange={(e: number) => {
                if (onChange) {
                    onChange({
                        target: {
                            name: "nhanvien",
                            value: e
                        }
                    });
                }
            }}
            allowClear={allowClear}
            /> :

            <Select
                style={{ width: '100%' }}
                showSearch
                placeholder="--Chọn đại diện phòng--"
                filterOption={function (search, item: any) {
                    return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
                }}
                options={data}
                disabled={disabled}
                value={value}
                onChange={(e: number) => {
                    if (onChange) {
                        onChange({
                            target: {
                                name: "nhanvien",
                                value: e
                            }
                        });
                    }
                }}
                allowClear={allowClear}
            />
    );
};

export default LanhDaoPhongBanSelectBox;
